import { serialize } from 'object-to-formdata'
import client from '../../client'
import {
  MeGradeNotificationsResponse,
  MeGradeHistoriesResponse,
  MeResponse,
  MeUpdateParams,
} from './types'

export * from './types'

export const get = async () => {
  const { data } = await client.get<MeResponse>('/user/me')
  return data
}

export const update = async (params: MeUpdateParams) => {
  return await client.post('/user/me', serialize(params), {
    headers: {
      'Content-Type': 'multipart/form-data',
      'X-HTTP-Method-Override': 'PUT',
    },
  })
}

export const getGradeNotification = async () => {
  const { data } = await client.get<MeGradeNotificationsResponse>(
    '/user/me/notifications'
  )
  return Array.isArray(data) ? null : data
}

export const markGradeNotificationAsRead = async () => {
  return await client.put(`/user/me/notifications/markAsRead`)
}

export const listGradeHistories = async () => {
  const { data } = await client.get<MeGradeHistoriesResponse>(
    '/user/me/histories'
  )
  return data
}
